/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/approve_reports/approveReportsModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 12:02:16 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Mon Dec 10 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import template from './views/ct_reports.html';
import controller from './controllers/classteacherController';
const name = "reportCardClassTeacher"
var module = angular.module(name, [
    //import modules
]).controller('studentListingForReports', controller);



// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('studentListingForReports', {
//             parent: 'app',
//             url: '/student-list-class-teacher',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'reportCardClassTeacherCtrl'
//                 }
//             }
//         })

// });


// WEBPACK FOOTER //
// ./src/app/report_cards/class_teacher/clasteacherModule.js